import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';

const CardImageModal = ({ toggle, modal, urlData, type }) => {
  //
  // console.log('urlData', urlData);
  const isArr = Array.isArray(urlData);

  async function downloadImage() {
    const today = new Date().getMinutes();
    const image = await fetch(urlData);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);

    const link = document.createElement('a');
    link.href = imageURL;
    link.crossOrigin = '*';

    link.download = type ? type : `photo-${today}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toggle();
  }

  const handleDownloadAll = async () => {
    const zip = new JSZip();
    const zipFileName = `validation.zip`;
    let fileCount = 0;
    for (let i = 0; i < urlData.length; i++) {
      const imageKeys = urlData[i] ? urlData[i] : '';
      let imageExt;

      if (imageKeys.includes('base64')) {
        const ext = imageKeys.substring(
          'data:image/'.length,
          imageKeys.indexOf(';base64')
        );
        imageExt = `.${ext}`;
      } else {
        imageExt = '.jpeg';
      }
      // console.log('imageKeys', imageKeys);
      let photoName = `validate-${i}${imageExt}`;

      JSZipUtils.getBinaryContent(
        imageKeys,
        // eslint-disable-next-line no-loop-func
        (err, photoData) => {
          if (err) {
            photoName = `file-missing-${i}`;
          }

          zip.file(photoName, photoData, {
            binary: true,
            createFolders: true,
          });
          fileCount++;

          if (fileCount === urlData.length) {
            zip
              .generateAsync({ type: 'blob' })
              .then((content) => saveAs(content, zipFileName))
              .catch((err) => console.log(err));
          }
        }
      );
    }
  };

  // console.log('urlData', urlData);

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Download Image</ModalHeader>
        <ModalBody>
          <div className="m-auto text-center">
            {isArr ? (
              <div>
                {urlData.map((e, idx) => {
                  return (
                    <div key={idx} className="mt-3 ">
                      <img src={e} alt="file" className="img-fluid" />
                    </div>
                  );
                })}
              </div>
            ) : (
              <img src={urlData} alt="file" className="img-fluid" />
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>

          <button
            onClick={() => (isArr ? handleDownloadAll() : downloadImage())}
            className="btn btn-primary"
          >
            Download
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CardImageModal;
